module.exports = __webpack_public_path__ + "img/WESicon3.fb0bac15.png";